// @ts-nocheck
if (!customElements.get('sticky-section-nav')) {
  class StickySectionNav extends HTMLElement {
    constructor() {
      super();
      this.navBar = this.querySelector('[data-nav-bar]');
      this.navButtons = this.querySelectorAll('[data-nav-button]');
      this.navList = this.querySelector('[data-nav-list]');
      this.observers = [];
      this.isManualScroll = false;
      this.stickyObserver = null;
    }

    connectedCallback() {
      this.setupClickHandlers();
      this.setupStickyBehavior();
      // Delay scroll-spy setup to ensure all sections are rendered
      requestAnimationFrame(() => {
        this.setupScrollSpy();
      });
    }

    disconnectedCallback() {
      this.observers.forEach((obs) => obs.disconnect());
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    getHeaderHeight() {
      const val = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height'));
      return isNaN(val) ? 67 : val;
    }

    // A nav item can carry a primary ID plus fallbacks, in order.
    // Returns the first one that is actually on the page.
    resolveTarget(btn) {
      const raw = btn.getAttribute('data-target-ids') || btn.getAttribute('data-target-id') || '';
      const ids = raw
        .split(',')
        .map((id) => id.trim().replace(/^#/, ''))
        .filter(Boolean);

      for (let i = 0; i < ids.length; i++) {
        const el = document.getElementById(ids[i]);
        if (el) return el;
      }
      return null;
    }

    setupClickHandlers() {
      this.navButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const targetEl = this.resolveTarget(btn);
          if (!targetEl) return;

          // Mark as manual scroll to prevent scroll-spy flicker
          this.isManualScroll = true;
          this.setActive(btn);

          const navHeight = this.navBar ? this.navBar.offsetHeight : 0;
          const stickyOffset = this.getHeaderHeight();
          const targetTop = targetEl.getBoundingClientRect().top + window.scrollY - navHeight - stickyOffset - 10;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth',
          });

          // Re-enable scroll spy after scroll completes
          setTimeout(() => {
            this.isManualScroll = false;
          }, 800);
        });
      });
    }

    setupStickyBehavior() {
      if (!this.navBar) return;

      // Detect when sticky nav is "stuck" using scroll position
      const checkSticky = () => {
        const rect = this.getBoundingClientRect();
        const headerHeight = this.getHeaderHeight();
        // When the element's top is at or near the header bottom, it's stuck
        if (rect.top <= headerHeight + 1) {
          this.classList.add('is-sticky');
        } else {
          this.classList.remove('is-sticky');
        }
      };

      window.addEventListener('scroll', checkSticky, { passive: true });
      checkSticky();
    }

    setupScrollSpy() {
      if (!this.navBar) return;
      const stickyOffset = this.getHeaderHeight();
      const navHeight = this.navBar.offsetHeight + stickyOffset + 20;

      this.navButtons.forEach((btn) => {
        const targetEl = this.resolveTarget(btn);
        if (!targetEl) return;

        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;
            if (this.isManualScroll) return;

            if (entry.isIntersecting) {
              this.setActive(btn);
            }
          },
          {
            rootMargin: `-${navHeight}px 0px -40% 0px`,
            threshold: 0,
          }
        );

        observer.observe(targetEl);
        this.observers.push(observer);
      });
    }

    setActive(activeBtn) {
      this.navButtons.forEach((btn) => {
        btn.classList.remove('is-active');
      });
      activeBtn.classList.add('is-active');

      // Scroll the active button into view within the nav (horizontal scroll)
      this.scrollNavToButton(activeBtn);
    }

    scrollNavToButton(btn) {
      if (!this.navList) return;
      const listRect = this.navList.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();

      // Check if button is out of visible area
      if (btnRect.left < listRect.left || btnRect.right > listRect.right) {
        const scrollLeft =
          btn.offsetLeft - this.navList.offsetWidth / 2 + btn.offsetWidth / 2;
        this.navList.scrollTo({
          left: scrollLeft,
          behavior: 'smooth',
        });
      }
    }
  }

  customElements.define('sticky-section-nav', StickySectionNav);
}
